
import toast from "react-hot-toast";

export default function ToastMessage(status, text) {
  if (status === 1) {
    toast.success(text);
  } else if (status === 0) {
    toast.error(text);
  } else if (status === 2) {
    toast.error(text);
  }
}
